// 20 cours types pour l'enseignement en salle
// Structure ECSR : Accueil · Découverte · Apports · Activité · Évaluation · Bilan
// Format opérationnel — directement utilisable en classe

const STRUCTURE = [
  { key: 'accueil', label: 'Accueil', duree: '2 min', color: '#18794e' },
  { key: 'decouverte', label: 'Découverte', duree: '5 min', color: '#1d4ed8' },
  { key: 'apports', label: 'Apports', duree: '15 min', color: '#cf2031' },
  { key: 'activite', label: 'Activité', duree: '10 min', color: '#f59e0b' },
  { key: 'evaluation', label: 'Évaluation', duree: '5 min', color: '#7c3aed' },
  { key: 'bilan', label: 'Bilan', duree: '3 min', color: '#0891b2' }
];

const cours = [
  {
    id: 'c01', theme: 'Regard', icon: 'Eye', niveau: 'Tous niveaux', duree: '40 min',
    objectif: 'Comprendre l\'impact du regard sur la trajectoire et la sécurité.',
    phraseCle: 'La moto va là où tu regardes.',
    accueil: ['Tour de table : "Qui a déjà ressenti que la moto va où on regarde ?"'],
    decouverte: ['Question : "Que se passe-t-il si je regarde un obstacle ?"', 'Échanges entre élèves.'],
    apports: [
      'Le regard sert à : diriger · anticiper · stabiliser.',
      'Mauvais regard : fixé · bas · tardif.',
      'Bon regard : loin · mobile · anticipé.'
    ],
    activite: ['Exercice : imaginer une trajectoire, dire où regarder.'],
    evaluation: ['QCM oral : regarder obstacle = ? · regarder loin = ?'],
    bilan: ['"Qu\'avez-vous retenu ?" · rappel : la moto va où tu regardes.'],
    dangers: ['Regarder l\'obstacle → chute', 'Regarder trop bas → trajectoire coupée'],
    solutions: ['Regarder loin', 'Anticiper']
  },
  {
    id: 'c02', theme: 'Anticipation', icon: 'Target', niveau: 'A2 / 125', duree: '40 min',
    objectif: 'Développer l\'anticipation en lecture de route.',
    phraseCle: 'Anticiper, c\'est voir avant que ça arrive.',
    accueil: ['"À votre avis, pourquoi les accidents arrivent-ils ?"'],
    decouverte: ['Vidéo accident ou situation décrite + échanges.'],
    apports: ['Voir → prévoir → agir.', 'Dangers fréquents : voiture qui tourne · piéton · refus priorité.'],
    activite: ['Analyse situation : "Que fais-tu ici ?"'],
    evaluation: ['3 questions rapides sur l\'anticipation.'],
    bilan: ['Importance de l\'anticipation dans la sécurité globale.'],
    dangers: ['Subir au lieu d\'anticiper', 'Confiance excessive envers les autres'],
    solutions: ['"Qu\'est-ce qui peut arriver ?"', 'Créer une marge de sécurité']
  },
  {
    id: 'c03', theme: 'Gestion du risque', icon: 'Shield', niveau: 'Tous niveaux', duree: '40 min',
    objectif: 'Comprendre et gérer le risque routier.',
    phraseCle: 'Le risque ne disparaît pas, il se gère.',
    accueil: ['"La moto est-elle dangereuse ?"'],
    decouverte: ['Échanges élèves : situations vécues.'],
    apports: ['Risque = environnement + comportement + véhicule.', 'Gérer : réduire vitesse · anticiper · se positionner.'],
    activite: ['Étude de cas concret.'],
    evaluation: ['QCM rapide.'],
    bilan: ['Responsabilité individuelle du conducteur.'],
    dangers: ['Nier le risque', 'Se croire invincible'],
    solutions: ['Identifier · évaluer · réduire', 'Adapter la conduite']
  },
  {
    id: 'c04', theme: 'Trajectoire de sécurité', icon: 'Route', niveau: 'Tous niveaux', duree: '40 min',
    objectif: 'Comprendre et appliquer la trajectoire de sécurité en virage.',
    phraseCle: 'Ta trajectoire, c\'est ta sécurité.',
    accueil: ['"Comment prenez-vous un virage ?"'],
    decouverte: ['Dessin au tableau + élèves expliquent.'],
    apports: ['Trajectoire = extérieur → intérieur → extérieur.', 'Objectifs : voir loin · être vu · stabiliser.', 'Erreurs : couper · rester au milieu · regard trop bas.'],
    activite: ['Tracer trajectoire sur schéma.'],
    evaluation: ['Identifier la bonne trajectoire.'],
    bilan: ['Lien direct avec la sécurité active.'],
    dangers: ['Couper le virage', 'Regard fixé sur l\'intérieur'],
    solutions: ['Placement extérieur en entrée', 'Regard vers la sortie']
  },
  {
    id: 'c05', theme: 'Freinage', icon: 'CircleDashed', niveau: 'Tous niveaux', duree: '40 min',
    objectif: 'Maîtriser la technique du freinage moto.',
    phraseCle: 'Freiner, c\'est doser.',
    accueil: ['"Freiner en moto, c\'est simple ?"'],
    decouverte: ['Expériences élèves + ressenti.'],
    apports: ['Freinage = progressif + équilibré.', 'Transfert de masse : poids vers l\'avant.', 'Erreurs : trop fort · oublier frein arrière.'],
    activite: ['Analyse situation freinage.'],
    evaluation: ['Quand freiner / comment.'],
    bilan: ['Dosage + anticipation = sécurité.'],
    dangers: ['Freiner en virage', 'Bloquer la roue avant'],
    solutions: ['Freiner AVANT le virage', 'Dosage avant/arrière']
  },
  {
    id: 'c06', theme: 'Intersections', icon: 'AlertTriangle', niveau: 'Tous niveaux', duree: '40 min',
    objectif: 'Sécuriser les intersections — lieu principal d\'accidents.',
    phraseCle: 'Même prioritaire, je vérifie.',
    accueil: ['"Où y a-t-il le plus d\'accidents moto ?"'],
    decouverte: ['Réponses élèves + stats accidentologie.'],
    apports: ['Dangers : refus priorité · visibilité · erreurs des autres.', 'Actions : ralentir · regarder · anticiper.'],
    activite: ['Analyse de 3 situations types.'],
    evaluation: ['Identifier le danger dans chaque situation.'],
    bilan: ['La priorité ne protège pas — la vigilance oui.'],
    dangers: ['Foncer parce que prioritaire', 'Ne pas voir les véhicules qui tournent'],
    solutions: ['Ralentir systématiquement', 'Observer les roues des véhicules']
  },
  {
    id: 'c07', theme: 'Équipement du motard', icon: 'Shirt', niveau: 'Tous niveaux', duree: '40 min',
    objectif: 'Comprendre l\'importance vitale de l\'équipement.',
    phraseCle: 'Ton équipement, c\'est ta carrosserie.',
    accueil: ['"Peut-on rouler sans équipement ?"'],
    decouverte: ['Échanges + photos blessures / chutes réelles.'],
    apports: ['Obligatoire : casque · gants CE.', 'Recommandé : blouson · pantalon · chaussures montantes · dorsale.', 'Réalité : chute = blessures graves sans équipement.'],
    activite: ['Associer chaque pièce d\'équipement à une protection spécifique.'],
    evaluation: ['QCM 3 questions.'],
    bilan: ['L\'équipement sauve des vies — pas de compromis.'],
    dangers: ['Rouler en t-shirt / sneakers', 'Casque non attaché'],
    solutions: ['Équipement complet TOUJOURS', 'Vérifier homologations CE']
  },
  {
    id: 'c08', theme: 'Distances de sécurité', icon: 'Ruler', niveau: 'Tous niveaux', duree: '40 min',
    objectif: 'Comprendre et respecter les distances de sécurité.',
    phraseCle: 'Plus je roule vite, plus j\'ai besoin d\'espace.',
    accueil: ['"Pourquoi garder une distance ?"'],
    decouverte: ['Calculs rapides : distance de réaction + freinage.'],
    apports: ['Distance = temps pour réagir.', 'Facteurs : vitesse · météo · fatigue.', 'Règle des 2 secondes.'],
    activite: ['Simulation / mise en situation.'],
    evaluation: ['Calculer une distance dans 3 situations.'],
    bilan: ['Distance = marge de décision.'],
    dangers: ['Coller', 'Sous-estimer la distance'],
    solutions: ['Règle des 2 secondes minimum', 'Doublée sous la pluie']
  },
  {
    id: 'c09', theme: 'Angles morts', icon: 'EyeOff', niveau: 'Tous niveaux', duree: '40 min',
    objectif: 'Comprendre le danger des angles morts.',
    phraseCle: 'Si tu ne vois pas le conducteur, il ne te voit pas.',
    accueil: ['"Un motard est-il toujours visible ?"'],
    decouverte: ['Démonstration angles morts camion / voiture.'],
    apports: ['Angle mort = zone invisible.', 'Solutions : se positionner · être visible · contrôler.'],
    activite: ['Placement sécuritaire dans 3 situations.'],
    evaluation: ['Identifier la bonne position.'],
    bilan: ['Visibilité = responsabilité partagée.'],
    dangers: ['Rester dans angle mort', 'Ne pas faire de contrôle visuel'],
    solutions: ['Se décaler', 'Vérifier par-dessus l\'épaule']
  },
  {
    id: 'c10', theme: 'Vitesse et risques', icon: 'Gauge', niveau: 'Tous niveaux', duree: '40 min',
    objectif: 'Comprendre l\'impact de la vitesse sur la sécurité.',
    phraseCle: 'La vitesse réduit tes chances de réagir.',
    accueil: ['"Pourquoi aime-t-on la vitesse ?"'],
    decouverte: ['Effet tunnel · perception réduite.'],
    apports: ['Vitesse = moins de temps + plus de distance de freinage.', 'Adapter à : météo · route · trafic.'],
    activite: ['Analyse situations vitesse inadaptée.'],
    evaluation: ['QCM rapide.'],
    bilan: ['La vitesse n\'est pas un droit, c\'est une responsabilité.'],
    dangers: ['Excès · vitesse inadaptée'],
    solutions: ['Adapter toujours', 'Anticiper plus loin']
  },
  {
    id: 'c11', theme: 'Conditions dégradées', icon: 'CloudRain', niveau: 'Tous niveaux', duree: '40 min',
    objectif: 'Adapter sa conduite aux conditions difficiles.',
    phraseCle: 'Moins de conditions = plus de prudence.',
    accueil: ['"Rouler sous la pluie, ça change quoi ?"'],
    decouverte: ['Retours d\'expérience élèves.'],
    apports: ['Pluie : adhérence réduite.', 'Nuit : visibilité réduite.', 'Vent : déséquilibre.', 'Adapter : vitesse · distance · trajectoire.'],
    activite: ['Étude cas : chaque élève choisit une condition difficile.'],
    evaluation: ['Identifier les adaptations nécessaires.'],
    bilan: ['Adaptation = clé de la sécurité.'],
    dangers: ['Rouler comme par beau temps', 'Ignorer les marquages mouillés'],
    solutions: ['Vitesse ÷ 2 minimum sous pluie', 'Distances doublées']
  },
  {
    id: 'c12', theme: 'Positionnement', icon: 'MapPin', niveau: 'Tous niveaux', duree: '40 min',
    objectif: 'Se positionner pour voir et être vu.',
    phraseCle: 'Ta place te protège.',
    accueil: ['"Où doit-on se placer en moto ?"'],
    decouverte: ['Schémas de placement à différents endroits.'],
    apports: ['Éviter angle mort · garder visibilité · adapter position.', 'Erreurs : trop à droite · trop près.'],
    activite: ['Positionnement dans 3 configurations.'],
    evaluation: ['QCM rapide.'],
    bilan: ['Placement dynamique = sécurité active.'],
    dangers: ['Rester à droite', 'Se cacher derrière un véhicule'],
    solutions: ['Tiers gauche en ville', 'Variable selon visibilité']
  },
  {
    id: 'c13', theme: 'Contrôles visuels', icon: 'Eye', niveau: 'Tous niveaux', duree: '40 min',
    objectif: 'Vérifier avant d\'agir.',
    phraseCle: 'Je regarde avant d\'agir.',
    accueil: ['"Quand vérifier et comment ?"'],
    decouverte: ['Démo triangle de vision.'],
    apports: ['Rétro · angle mort · regard loin.', 'Erreurs : oublier · trop tardif.'],
    activite: ['Séquence de contrôles avant chaque action.'],
    evaluation: ['Valider la bonne séquence.'],
    bilan: ['Automatisation des contrôles = réflexe de sécurité.'],
    dangers: ['Changer de voie sans contrôler', 'Rétro rarement utilisés'],
    solutions: ['Séquence C-S-D (Contrôler → Signaler → Décider)', 'Rétro toutes les 5 sec']
  },
  {
    id: 'c14', theme: 'Dépassements', icon: 'ArrowRightLeft', niveau: 'A2 / A', duree: '40 min',
    objectif: 'Dépasser en sécurité.',
    phraseCle: 'Doubler, c\'est décider.',
    accueil: ['"Quand doit-on renoncer à doubler ?"'],
    decouverte: ['Analyse situations risquées.'],
    apports: ['Visibilité · distance · décision.', 'Erreurs : dépassement risqué · mauvaise analyse.'],
    activite: ['Séquence C-S-D appliquée à 3 situations (rétros + angle mort, clignotant, manœuvre).'],
    evaluation: ['Identifier si le dépassement est autorisé.'],
    bilan: ['Doubler = responsabilité totale.'],
    dangers: ['Dépasser en virage', 'Sous-estimer la vitesse en face'],
    solutions: ['Doubler franchement ou renoncer', 'Pas d\'hésitation']
  },
  {
    id: 'c15', theme: 'Carrefours à sens giratoire (CSG)', icon: 'RotateCw', niveau: 'Tous niveaux', duree: '40 min',
    objectif: 'Circuler en sécurité dans les CSG.',
    phraseCle: 'J\'observe avant d\'entrer.',
    accueil: ['"Comment aborder un CSG ?"'],
    decouverte: ['Schéma insertion / trajectoire / sortie.'],
    apports: ['Insertion · trajectoire · sortie.', 'Erreurs : mauvaise voie · oubli regard.'],
    activite: ['Tracer trajectoires dans 3 CSG types.'],
    evaluation: ['Choisir la voie selon la sortie visée.'],
    bilan: ['CSG = anticipation obligatoire.'],
    dangers: ['Changer de voie dedans', 'Sortir sans contrôle'],
    solutions: ['Choisir sa voie AVANT', 'Clignoter avant la sortie']
  },
  {
    id: 'c16', theme: 'Fatigue & vigilance', icon: 'Moon', niveau: 'Tous niveaux', duree: '40 min',
    objectif: 'Comprendre les effets de la fatigue sur la conduite.',
    phraseCle: 'Fatigué = danger.',
    accueil: ['"Quand êtes-vous le plus fatigué ?"'],
    decouverte: ['Signes avant-coureurs de fatigue.'],
    apports: ['Baisse attention · réflexes ralentis · micro-sommeil.', 'Erreurs : continuer malgré fatigue.'],
    activite: ['Identifier ses propres signaux de fatigue.'],
    evaluation: ['Stratégies anti-fatigue.'],
    bilan: ['La fatigue tue autant que l\'alcool.'],
    dangers: ['Partir tôt après nuit courte', 'Ne pas faire de pause longue distance'],
    solutions: ['Pause toutes les 2h', 'Sommeil avant trajet long']
  },
  {
    id: 'c17', theme: 'Alcool & stupéfiants', icon: 'Wine', niveau: 'Tous niveaux', duree: '40 min',
    objectif: 'Comprendre les dangers et la tolérance zéro.',
    phraseCle: 'Conduire = être lucide.',
    accueil: ['"Peut-on rouler après un verre ?"'],
    decouverte: ['Taux légal · effets réels.'],
    apports: ['Perte réflexes · mauvaise décision.', 'Effets sous-estimés.', 'Tolérance zéro chez jeunes conducteurs.'],
    activite: ['Temps d\'élimination de l\'alcool.'],
    evaluation: ['QCM.'],
    bilan: ['Un verre = plus rien au volant.'],
    dangers: ['"Un petit verre ça passe"', 'Lendemain de soirée'],
    solutions: ['Zéro alcool sur deux roues', 'Planifier un retour sans alcool']
  },
  {
    id: 'c18', theme: 'Piétons & usagers fragiles', icon: 'Users', niveau: 'Tous niveaux', duree: '40 min',
    objectif: 'Protéger les usagers les plus vulnérables.',
    phraseCle: 'Le plus fragile est prioritaire.',
    accueil: ['"Qui est le plus vulnérable sur la route ?"'],
    decouverte: ['Hiérarchie des vulnérabilités.'],
    apports: ['Anticiper · ralentir · protéger.', 'Enfants · personnes âgées · cyclistes.'],
    activite: ['3 situations : comment tu agis ?'],
    evaluation: ['Identifier le bon comportement.'],
    bilan: ['Partager la route = respecter le plus fragile.'],
    dangers: ['Foncer près d\'un passage piéton', 'Ignorer un cycliste'],
    solutions: ['Ralentir systématiquement', 'Anticiper leurs mouvements']
  },
  {
    id: 'c19', theme: 'Conduite défensive', icon: 'ShieldCheck', niveau: 'Tous niveaux', duree: '40 min',
    objectif: 'Anticiper les erreurs des autres usagers.',
    phraseCle: 'Je ne fais confiance à personne.',
    accueil: ['"Faites-vous confiance aux autres conducteurs ?"'],
    decouverte: ['Exemples d\'erreurs courantes.'],
    apports: ['Prévoir · se protéger · ne pas provoquer.', 'Créer des marges en permanence.'],
    activite: ['Situations "défensives" à identifier.'],
    evaluation: ['Bonne réaction face aux erreurs.'],
    bilan: ['Conduite défensive = conduite de survie.'],
    dangers: ['Se reposer sur le Code des autres', 'Provoquer'],
    solutions: ['Marge permanente', 'Anticiper les erreurs']
  },
  {
    id: 'c20', theme: 'Bilan — être un bon motard', icon: 'Trophy', niveau: 'Tous niveaux', duree: '40 min',
    objectif: 'Synthétiser la formation et définir le profil du motard responsable.',
    phraseCle: 'Un bon motard = prudent, anticipatif, responsable.',
    accueil: ['"Qu\'est-ce qu\'un bon motard ?"'],
    decouverte: ['Échanges + définition collective.'],
    apports: ['Anticiper · respecter · maîtriser · partager.', 'Lien entre technique, comportement, responsabilité.'],
    activite: ['Auto-évaluation de chaque élève.'],
    evaluation: ['Objectif personnel post-formation.'],
    bilan: ['Le permis est un début, pas une fin.'],
    dangers: ['Relâcher après le permis', 'Croire qu\'on a tout appris'],
    solutions: ['Continuer à apprendre', 'Rester humble']
  }
];

export { STRUCTURE, cours as coursSalle };

/**
 * Adaptateur cours Salle → format <PedagogicalCanvas trameId="salle"> (REMC 7 étapes).
 *
 * Mapping legacy (6 étapes) → TRAME_SALLE (7 étapes officielles) :
 *   accueil          → accueil          (Accueil & mise en situation)
 *   [nouveau]        → objectif         (dérivé du champ `objectif` du cours)
 *   decouverte       → representations  (Recueil des représentations)
 *   apports          → cours            (Apport de connaissances)
 *   activite         → verification     (Vérification de compréhension)
 *   bilan            → synthese         (Synthèse / Bilan)
 *   evaluation       → evaluation       (Évaluation des acquis)
 *
 * Les `dangers` et `solutions` du cours sont fusionnés en supplément
 * (sous-bloc « Points de vigilance ») dans l'étape `cours` (Apport).
 *
 * Retourne :
 *   { title, kicker, accent, meta, steps }   ← consommable direct par PedagogicalCanvas
 */
export function getCoursSalleAsCanvas(c) {
  if (!c) return null;
  const toItems = (arr) => (Array.isArray(arr) ? arr.filter(Boolean) : []);

  // Construction du contenu "cours" enrichi des dangers/solutions
  const coursItems = toItems(c.apports);
  if (c.dangers?.length) {
    coursItems.push('<strong>⚠ Pièges à éviter :</strong>');
    coursItems.push(...toItems(c.dangers).map((d) => `→ ${d}`));
  }
  if (c.solutions?.length) {
    coursItems.push('<strong>✓ Bons réflexes :</strong>');
    coursItems.push(...toItems(c.solutions).map((s) => `→ ${s}`));
  }

  return {
    title: c.theme,
    kicker: `${c.id?.toUpperCase()} · ${c.niveau} · ${c.duree}`,
    accent: '#1d4ed8', // bleu trame salle officielle
    icon: c.icon,
    summary: c.objectif,
    phraseCle: c.phraseCle,
    meta: {
      duree: c.duree,
      niveau: c.niveau,
      lieu: 'Salle de cours',
      objectif: c.objectif,
    },
    steps: {
      accueil: {
        content: 'Mise en situation & captation :',
        items: toItems(c.accueil),
      },
      objectif: {
        content: `« ${c.objectif} »`,
        notes: c.phraseCle ? `Phrase-clé à retenir : « ${c.phraseCle} »` : null,
      },
      representations: {
        content: 'Recueil des représentations élèves :',
        items: toItems(c.decouverte),
      },
      cours: {
        content: 'Apport de connaissances :',
        items: coursItems,
      },
      verification: {
        content: "Mise en activité — vérification de la compréhension :",
        items: toItems(c.activite),
      },
      synthese: {
        content: "Synthèse / bilan de la séance :",
        items: toItems(c.bilan),
      },
      evaluation: {
        content: "Évaluation des acquis :",
        items: toItems(c.evaluation),
      },
    },
  };
}

/** Retourne un cours salle par son id (c01..c20). */
export function getCoursSalleById(id) {
  return cours.find((x) => x.id === id) || null;
}
